export const SET_ALL_OFFERS = "Setzt die Angebote im Store";
export const SET_CURRENT_OFFER = "Setzt das aktuelle Angebot im Store";
